import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "store-management",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const storeManagement = require("./StoreManagement").default;
          cb(null, storeManagement);
        },
        "StoreManagement"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/StoreManagement/index.js